import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import FontAwesome from 'react-fontawesome';
import { withRouter } from 'react-router';
import { mapsLoaded, removeMap } from '../../actions';
import { COLOUR_BRANDING_OFF } from '../../js';
import { checkLoggedIn, validateAccess } from '../../session';
import { mapActions } from '../../webapi';
import { AddButton } from '../../components';
import { Text } from '../../components/text';

class Maps extends Component {
  state = {
    mapList: [],
    showCompleted: false,
    sortColumn: 'title',
    sortDesc: false,

    loading: true,
  };

  UNSAFE_componentWillMount() {
    this.updateProps(this.props);
    checkLoggedIn(this, this.props.auth);
  }

  componentDidMount() {
    this.getData();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.updateProps(nextProps);
  }

  updateProps(props) {
    this.setState({
      mapList: props.maps,
    });
  }

  getData() {
    mapActions.getMaps(this.props.auth.site).then((res) => {
      if (res.data != null) {
        this.props.mapsLoaded(res.data);
      }
      this.setState({ loading: false });
    });
  }

  removeMap(ev) {
    if (window.confirm(`Are you sure you want to delete ${ev.title}?`)) {
      mapActions
        .deleteMap(this.props.auth.site, ev.RowId)
        .then((res) => {
          this.getData();
          // action
          console.log('success');
          this.props.removeMap(ev.RowId);
        })
        .catch((res) => {
          alert('Something went wrong with the request. Please try again.');
        });
    }
  }

  sortByCol(col) {
    if (this.state.sortColumn === col) {
      this.setState({
        sortDesc: !this.state.sortDesc,
      });
    } else {
      this.setState({
        sortColumn: col,
        sortDesc: false,
      });
    }
  }

  renderList() {
    let source = _.sortBy(this.state.mapList, this.state.sortColumn);
    if (this.state.sortDesc) {
      source.reverse();
    }
    source = _.filter(source, (ev) => {
      if (!ev) {
        return false;
      }
      return true;
    });

    return source.map((ev, index) => {
      if (ev != null) {
        return (
          <tr key={index}>
            <td className="table-TitleColumn">
              <Link to={`/info/map/${ev.RowId}`}>{ev.title}</Link>
            </td>
            {validateAccess(this.props.auth.site, 'maps', this.props.auth) && (
              <td className="table-options">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Link to={`/info/map/${ev.RowId}`}>
                    <FontAwesome style={{ fontSize: 20, padding: 5, marginLeft: 12, cursor: 'pointer' }} name="pencil" />
                  </Link>
                  <a
                    onClick={() => {
                      this.removeMap(ev);
                    }}
                  >
                    <FontAwesome style={{ fontSize: 20, padding: 5, marginLeft: 8, cursor: 'pointer' }} name="minus-circle" />
                  </a>
                </div>
              </td>
            )}
          </tr>
        );
      }
      return null;
    });
  }

  addNew() {
    this.props.history.push(`/info/map`);
  }

  renderView() {
    return (
      <Table className="plussTable" striped bordered condensed hover style={{ minWidth: '100%' }}>
        <thead>
          <tr>
            <th
              style={{ cursor: 'pointer' }}
              onClick={() => {
                this.sortByCol('title');
              }}
            >
              Title
            </th>
            <th style={{ width: 70 }} />
          </tr>
        </thead>
        <tbody>{this.renderList()}</tbody>
      </Table>
    );
  }

  renderEmpty() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'center', alignItems: 'center', marginTop: 32 }}>
        <div className="emptyState" />
        <div className="marginTop-32" style={{ maxWidth: 500, textAlign: 'center' }}>
          <Text type="h3">There are no maps</Text>
        </div>
      </div>
    );
  }

  renderContent() {
    if (_.isEmpty(this.state.mapList)) {
      return this.renderEmpty();
    }
    return this.renderView();
  }

  render() {
    if (this.state.mapList.length === 0 && this.state.loading) {
      return (
        <div style={{ minWidth: '100%' }}>
          <div className="padding-60 paddingVertical-40" style={{ textAlign: 'center' }}>
            <FontAwesome style={{ fontSize: 30, color: COLOUR_BRANDING_OFF }} name="spinner fa-pulse fa-fw" />
          </div>
        </div>
      );
    }
    return (
      <div style={{ minWidth: '100%' }}>
        {this.renderContent()}
        <div className="hub_tidioPadding"></div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { maps } = state.maps;
  const { auth } = state;
  return { maps, auth };
};

export default connect(mapStateToProps, { mapsLoaded, removeMap })(withRouter(Maps));
